//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import colors from "vuetify/es5/util/colors";
import { mapState } from "vuex";

export default {
  props: {
    item: {
      type: Object
    }
  },
  created: function () {
    let data = [];
    this.item["values"].forEach(function (val) {
      if (val > 0) {
        data.push("+" + val);
      } else if (val == 0) {
        data.push(val.toString());
      } else {
        data.push(val);
      }
    });
    this.ticklabels = data;
  },
  data: function () {
    return {
      label: this.item.id,
      sliderValue: 0,
      ticklabels: [],
    };
  },
  computed: {
    ...mapState({
      drillingInProgress: state => state.drilling.drillingInProgress,
    })
  },
  methods: {
    onClick: function () {
      let val = this.item.values[this.sliderValue]
      if (val > 0) {
        val = "+" + val;
      }
      this.$emit("slider-change", this.item["id"], val);
    }
  },
};
